
























































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import AccordionSelect from '@/components/AccordionSelect.vue'
import PdfViewer from '@/components/PdfViewer.vue'
import ScrollView from '@/components/ScrollView.vue'

import { TemplateModule } from '@/store/modules/template.module'
import {
  ETemplateField,
  ETemplateType,
  ETransactionEffectiveDateStatus,
  EUserPermissions,
  ITemplate,
  TEMPLATE_FIELDS_MAP
} from '@zunta/configurations'
import { IAccoridionElementItem } from '@/interfaces'
import { copyText } from '@/utils/helpers'
import Api from '@/api'
import { User } from '@/classes/User'
import Card from '@/components/Card.vue'
import GoBack from '@/components/GoBack.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputFileV2 from '@/components/inputsV2/InputFileV2.vue'
import { required, requiredIf } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

const { Editor, EditorContent, EditorMenuBar } = require('tiptap')
const {
  Bold,
  Italic,
  Underline
} = require('tiptap-extensions')
@Component({
  components: {
    LoaderWrapper,
    InputValidator,
    InputFileV2,
    InputV2,
    SelectV2,
    GoBack,
    Card,
    AccordionSelect,
    PdfViewer,
    EditorMenuBar,
    EditorContent,
    ScrollView
  }
})
export default class SetupTemplate extends Vue {
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  EUserPermissions: any = EUserPermissions
  ETemplateType: any = ETemplateType
  user: User = Api.getUser() as User
  isCopied: boolean = false

  templateData: Partial<ITemplate> = {
    type: undefined,
    templateName: '',
    title: '',
    body: '',
    fileName: ''
  }

  isLoading: boolean = false
  forceUpdater: number = 0

  editor: any = null

  validations (): any {
    return {
      templateData: {
        type: {
          required
        },
        templateName: {
          required
        },
        title: {
          // required: requiredIf(() => this.templateData.type !== ETemplateType.LETTER_PDF)
        },
        body: {
          required: requiredIf(() => this.templateData.type !== ETemplateType.LETTER_PDF)
        },
        fileName: {
          required: requiredIf(() => this.templateData.type === ETemplateType.LETTER_PDF)
        }
      }
    }
  }

  get facilityId () {
    return this.$route.params.facilityId
  }

  get templateType () {
    if (this.templateData.type === ETemplateType.LETTER) {
      return 'template'
    }
    if (this.templateData.type === ETemplateType.MESSAGE) {
      return 'statement-message'
    }
    if (this.templateData.type === ETemplateType.LETTER_PDF) {
      return 'pdf-template'
    }
    return ''
  }

  get isNew () {
    return this.$route.params.templateId === 'new'
  }

  get templateId () {
    return this.$route.params.templateId
  }

  get selectedTemplate () {
    return this.$store.state.template.selectedTemplate
  }

  get PDFSrc () {
    return this.templateData.type === ETemplateType.LETTER_PDF ? this.templateData.fileName : this.templateId
  }

  get showPdfViewer () {
    if (this.templateData.type === ETemplateType.LETTER_PDF) {
      return !!this.templateData.fileName
    }
    return !this.isNew
  }

  get fieldSelectListItems () {
    const listItems: any[] = [
      {
        title: 'Facility Fields',
        key: 'facility-fields',
        items: this.facilityFieldsList
      },
      {
        title: 'Resident Fields',
        key: 'resident-fields',
        items: this.residentFieldsList
      }
    ]
    if (this.templateType === 'template') {
      listItems.push({
        title: 'Payment and Balance Details',
        key: 'Payment and Balance Details',
        items: this.paymentAndBalanceDetailsList
      })
    }
    return listItems
  }

  get templateTypesList () {
    return [
      {
        value: ETemplateType.LETTER,
        key: ETemplateType.LETTER,
        content: 'Letter'
      },
      {
        value: ETemplateType.MESSAGE,
        key: ETemplateType.MESSAGE,
        content: 'Statement Message'
      },
      {
        value: ETemplateType.LETTER_PDF,
        key: ETemplateType.LETTER_PDF,
        content: 'Letter Upload'
      }
    ]
  }

  get facilityFieldsList () {
    return [
      {
        key: ETemplateField.FACILITY_NAME,
        value: ETemplateField.FACILITY_NAME,
        content: 'Facility Name'
      },
      {
        key: ETemplateField.FACILITY_PHONE,
        value: ETemplateField.FACILITY_PHONE,
        content: 'Facility Phone'
      },
      {
        key: ETemplateField.FACILITY_WEBSITE,
        value: ETemplateField.FACILITY_WEBSITE,
        content: 'Facility Website'
      },
      {
        key: ETemplateField.FACILITY_ADDRESS,
        value: ETemplateField.FACILITY_ADDRESS,
        content: 'Facility Address'
      },
      {
        key: ETemplateField.BILLING_CONTACT_NAME,
        value: ETemplateField.BILLING_CONTACT_NAME,
        content: 'Billing Contact Name'
      },
      {
        key: ETemplateField.BILLING_CONTACT_EMAIL,
        value: ETemplateField.BILLING_CONTACT_EMAIL,
        content: 'Billing Contact Email'
      },
      {
        key: ETemplateField.BILLING_CONTACT_PHONE,
        value: ETemplateField.BILLING_CONTACT_PHONE,
        content: 'Billing Contact Phone'
      }
    ]
  }

  get residentFieldsList () {
    return [
      {
        key: ETemplateField.RESIDENT_FIRST_NAME,
        value: ETemplateField.RESIDENT_FIRST_NAME,
        content: 'Resident First Name'
      },
      {
        key: ETemplateField.RESIDENT_LAST_NAME,
        value: ETemplateField.RESIDENT_LAST_NAME,
        content: 'Resident Last Name'
      },
      {
        key: ETemplateField.RESIDENT_ID,
        value: ETemplateField.RESIDENT_ID,
        content: 'Resident ID'
      },
      {
        key: ETemplateField.RESIDENT_STATUS,
        value: ETemplateField.RESIDENT_STATUS,
        content: 'Resident Status'
      },
      // {
      //   key: ETemplateField.MAILING_CONTACT_NAME,
      //   value: ETemplateField.MAILING_CONTACT_NAME,
      //   content: 'Mail Contact Name'
      // },
      {
        key: ETemplateField.MAILING_CONTACT_FIRST_NAME,
        value: ETemplateField.MAILING_CONTACT_FIRST_NAME,
        content: 'Recipient First Name'
      },
      {
        key: ETemplateField.MAILING_CONTACT_LAST_NAME,
        value: ETemplateField.MAILING_CONTACT_LAST_NAME,
        content: 'Recipient Last Name'
      },
      {
        key: ETemplateField.MAILING_CONTACT_ADDRESS,
        value: ETemplateField.MAILING_CONTACT_ADDRESS,
        content: 'Mail Contact Address'
      }
      // {
      //   key: ETemplateField.PRIMARY_PAYMENT_METHOD,
      //   value: ETemplateField.PRIMARY_PAYMENT_METHOD,
      //   content: 'Primary Payment Method'
      // }
    ]
  }

  get paymentAndBalanceDetailsList () {
    return [
      // {
      //   content: 'Open Item Detail',
      //   key: 'Open Item Detail',
      //   value: ETemplateField.OPEN_ITEM_DETAILS
      // },
      // {
      //   content: 'Open Item Summary',
      //   key: 'Open Item Summary',
      //   value: ETemplateField.OPEN_ITEM_SUMMARY
      // },
      {
        content: 'Total Balance',
        key: 'Total Balance',
        value: ETemplateField.TOTAL_BALANCE,
        extraCheckboxesList: [{
          title: 'Which Statuses do you want to include in the total?',
          list: [{
            key: ETransactionEffectiveDateStatus.BILLED,
            value: ETransactionEffectiveDateStatus.BILLED,
            content: 'Billed'
          }, {
            key: ETransactionEffectiveDateStatus.DUE,
            value: ETransactionEffectiveDateStatus.DUE,
            content: 'Due'
          }, {
            key: ETransactionEffectiveDateStatus.OVERDUE,
            value: ETransactionEffectiveDateStatus.OVERDUE,
            content: 'Overdue'
          }, {
            key: ETransactionEffectiveDateStatus.DELINQUENT,
            value: ETransactionEffectiveDateStatus.DELINQUENT,
            content: 'Delinquent'
          }]
        }]
      }
    ]
  }

  async mounted () {
    if (!this.isNew) {
      await this.templateModuleInstance.fetchTemplateById(this.templateId)
      if (this.selectedTemplate) {
        this.templateData = { ...this.selectedTemplate }
      }
    } else if (this.$route.query.type) {
      this.templateData.type = this.$route.query.type as ETemplateType
    }

    this.editor = new Editor({
      extensions: [
        // new extensions should be handled during generation: string length calculation (zunta-letters:getAmountOfStrings)
        new Bold(),
        new Italic(),
        new Underline()
      ],
      onUpdate: () => {
        this.isCopied = false
        this.setContent(this.editor.getHTML())
      },
      content: this.templateData.body
    })
  }

  beforeDestroy () {
    this.templateModuleInstance.resetSelectedTemplate()
  }

  goBack () {
    this.$locationManager.goBack({ name: 'management-templates' })
  }

  async selectPDFLetterToUpload (item: any): Promise<any> {
    const res = await this.templateModuleInstance.uploadPDFLetter(item)
    if (typeof res === 'string') {
      const regex = /pdf-letters\/(.*)/gm
      this.templateData.fileName = res.replace(regex, '$1')
    }
  }

  copySelectedValue (item: IAccoridionElementItem) {
    this.isCopied = true
    const field = TEMPLATE_FIELDS_MAP[item.value as string]

    if (item.value !== ETemplateField.TOTAL_BALANCE) {
      copyText(field)
      return
    }

    const data = JSON.parse(field)

    if (item.checked) {
      data.statuses = item.checked[0]
    }

    copyText(JSON.stringify(data))
  }

  setContent (val: string) {
    const repVal = val.replace(/&nbsp;/gm, ' ')
    if (this.templateData.type !== ETemplateType.LETTER_PDF &&
      !repVal.replace(/<\/?[^>]+(>|$)/g, ' ').trim().length) {
      this.templateData.body = ''
      return
    }
    this.templateData.body = repVal
  }

  async save () {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_TEMPLATES)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: 'Modify Template',
        icon: 'warning'
      })
      return
    }

    this.$v.$touch()

    // @ts-ignore
    if (this.$v.$anyError || (this.$refs.file && this.$refs.file.isLoading)) {
      return
    }

    let header = ''
    let message = ''
    let template
    let icon = 'check'

    try {
      this.isLoading = true
      if (this.isNew) {
        header = 'Add Template'
        template = await this.templateModuleInstance.addTemplate(this.templateData)
        message = 'Template added successfully'
      } else {
        header = 'Update Template'
        template = await this.templateModuleInstance.updateTemplate({
          templateId: this.templateId,
          data: this.templateData
        })
        message = 'Template updated successfully'
      }
    } catch (e) {
      header = 'Add Template'
      message = 'Something went Wrong'
      icon = 'warning'
    } finally {
      this.$eventBus.$emit('notify', {
        color: icon === 'warning' ? 'var(--status-error-color)' : 'var(--status-success-color)',
        message: message,
        header: header,
        icon: icon
      })
      if (window.opener) {
        window.opener.postMessage({ type: 'refreshChainTemplates' }, '*')
      }
      this.isLoading = false
      this.forceUpdater++
      if (this.isNew && template) {
        await this.$router.push({
          name: 'management-template',
          params: { templateId: template.id.toString() }
        })
      }
    }
  }
}
